import dayjs from 'dayjs';

export const startOfDay = (date: Date): Date => {
  return dayjs(date).startOf('day').toDate();
};
